<div class="drawer lg:drawer-open">
  <input
    id="gb-sidebar-drawer"
    type="checkbox"
    class="drawer-toggle"
    [checked]="drawerOpen"
    (change)="toggleDrawer()"
  />
  <div class="drawer-content">
    <router-outlet />
  </div>
  <div class="drawer-side">
    <label for="gb-sidebar-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
    <nav class="menu bg-base-200 text-base-content min-h-full w-64 p-4">
      <!-- Sidebar navigation will be wired during migration phase -->
      <li class="menu-title">Navigation</li>
    </nav>
  </div>
</div>
